import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {SLICE_PROP_TYPES} from '../cms-prop-types';
import {RichText} from 'prismic-reactjs';
// Creating in advance of using CSS modudles with dex
// import css from './FAQWithTitle.module.scss';

/* NOTE: For the rich text in the FAQ answers to render as a string in the structured data it must use RichText.asText instead of RichText.render */
const FAQWithTitle = ({slice}) => (
    <div className="FAQWithTitle">
        <h2>{slice.primary.title}</h2>
        {slice.items.map((faq, i) => (
            <Fragment key={i}>
                <h3>{faq.question}</h3>
                {RichText.render(faq.answer)}
            </Fragment>
        ))}

        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: `{
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [${slice.items.map(
                        faq =>
                            `{
                                "@type": "Question",
                                "name": "${faq.question}",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "${RichText.asText(faq.answer)}"
                                }
                            }`
                    )}]
                }`,
            }}
        />
    </div>
);

/* eslint-disable camelcase */
FAQWithTitle.propTypes = {
    slice: PropTypes.shape({
        ...SLICE_PROP_TYPES,
        primary: PropTypes.shape({
            title: PropTypes.string.isRequired,
        }).isRequired,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                question: PropTypes.string.isRequired,
                answer: PropTypes.array.isRequired,
            })
        ).isRequired,
    }).isRequired,
};

export default FAQWithTitle;
